<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw" :class="{'fas': active, 'far': !active, 'fa-comment': response.response, 'fa-ban': !response.response, 'ban': !response.response}"></i></template>
        <template v-slot:content>
            <div class="tile-title" v-if="response.response">{{response.response}}</div>
            <div class="tile-title ban" v-else><em>No Response</em></div>
            <div class="meta" v-if="showUser"><i class="far fa-fw fa-user mr-2"></i>{{response.user.first_name}} {{response.user.last_name}}</div>
        </template>
        <template v-slot:status>

        </template>
        <template v-slot:details>
            <div class="details-rollout">
                <toolbar class="toolbar">
                    <button class="icon-only" @click.stop="$openCard('user', {}, card)"><i class="far fa-user"></i></button>
                    <button class="icon-only" @click.stop="$openCard('registration', {registrationId: response.registration_id}, card)"><i class="far fa-suitcase"></i></button>
                    <button class="icon-only" @click.stop="$openCard('responses', {registrationId: response.registration_id}, card)"><i class="far fa-clipboard-list-check"></i></button>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{response.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "../TIER/components/Toolbar";
    import DataRow from "../TIER/components/DataRow";
    import CardListItem from "../TIER/components/CardListItem";

    export default {
        name: 'TripResponseListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            response: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            showUser: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                details: false
            }
        }
    }
</script>

<style lang="scss" scoped>

    li {
        color: darken($t-primary, 10);

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        padding: 0.5rem 0;

        .details-rollout {
            margin-top: 0.5rem;
        }


    }

    .ban {
        color: #f9b000 !important;
    }

    .drag-handle {
        cursor: ns-resize;
    }
</style>
